import React from 'react'

const GstSplit = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 128 128"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#ffdb80"
                        d="M94.75 28.88v64.54L92 96.83H35.5l-2.93-2.93v-9.94c.11.13.21.28.33.41l7.41 8.56a.462.462 0 0 0 .07.07 5.966 5.966 0 0 0 4.46 2 5.875 5.875 0 0 0 2.12-.39l.19-.07A6.063 6.063 0 0 0 49.41 93a5.922 5.922 0 0 0 1.57-4.54l-.89-11.04a40.061 40.061 0 0 0-3.03-12.3l-1.07-2.52a5.934 5.934 0 0 0-.42-2.27l-12.75-31.7c-.07-.18-.17-.34-.25-.52V17.19l3.49-1.86h44.27z"
                        opacity={1}
                        data-original="#ffdb80"
                        className="hovered-path"
                    />
                    <path
                        fill="#e1ebf4"
                        d="M125.75 27.98v76.12h-123V27.98h9.75a5.027 5.027 0 0 0-.43.49 3.9 3.9 0 0 0-.32.42.481.481 0 0 0-.09.11 8.837 8.837 0 0 0-.94 1.67c-.05.11-.09.22-.13.33a8.823 8.823 0 0 0 .06 6.53l12.74 31.7a5.876 5.876 0 0 0 2.02 2.59l.73 1.73a40.834 40.834 0 0 0 2.64 5.14A3.977 3.977 0 0 0 27 82v11a10.015 10.015 0 0 0 10 10h54a10.015 10.015 0 0 0 10-10V29a5.775 5.775 0 0 0-.09-1.02z"
                        opacity={1}
                        data-original="#e1ebf4"
                        className=""
                    />
                    <path
                        fill="#2d4356"
                        d="M47 21h-8a2 2 0 0 0 0 4h2v7a2 2 0 0 0 4 0v-7h2a2 2 0 0 0 0-4zM60 34a2 2 0 0 0 2-2v-5a6 6 0 0 0-12 0v5a2 2 0 0 0 4 0v-1h4v1a2 2 0 0 0 2 2zm-6-7a2 2 0 0 1 4 0zM64.771 33.583a2 2 0 0 0 2.784-.5l1.41-2.03 1.37 2.056a2 2 0 0 0 3.33-2.218l-2.246-3.367 2.31-3.323a2 2 0 0 0-3.284-2.284l-1.41 2.03-1.37-2.056a2 2 0 1 0-3.33 2.218l2.246 3.367-2.31 3.323a2 2 0 0 0 .5 2.784zM41 43a2 2 0 0 0 2 2h42a2 2 0 0 0 0-4H43a2 2 0 0 0-2 2zM46.99 88.78l-.89-11.04a35.746 35.746 0 0 0-2.73-11.07l-1.47-3.49a2.05 2.05 0 0 0-.04-1.36l-12.75-31.7a4.986 4.986 0 0 0-6.47-2.76l-5.52 2.21a4.97 4.97 0 0 0-2.76 6.47l12.75 31.71a1.98 1.98 0 0 0 1.42 1.19l1.29 3.05a36.928 36.928 0 0 0 6.1 9.76l7.41 8.56a1.988 1.988 0 0 0 1.51.69 1.94 1.94 0 0 0 .71-.13l.16-.06a1.99 1.99 0 0 0 1.28-2.03zM18.07 34.55a.949.949 0 0 1 .01-.74.977.977 0 0 1 .53-.52l5.52-2.22a.921.921 0 0 1 .36-.07.975.975 0 0 1 .91.61l1.27 3.17-7.33 2.93zm2.76 6.87 7.33-2.93 9.24 22.97-7.33 2.94zm18.11 37.71a32.882 32.882 0 0 1-5.43-8.7l-1.12-2.65 6.08-2.44 1.22 2.89a31.64 31.64 0 0 1 2.42 9.83l.43 5.22z"
                        opacity={1}
                        data-original="#2d4356"
                        className=""
                    />
                    <path
                        fill="#fc785e"
                        d="m26.67 34.78-7.33 2.93-1.27-3.16a.949.949 0 0 1 .01-.74.977.977 0 0 1 .53-.52l5.52-2.22a.921.921 0 0 1 .36-.07.975.975 0 0 1 .91.61z"
                        opacity={1}
                        data-original="#fc785e"
                    />
                    <path
                        fill="#81d9e3"
                        d="m37.4 61.46-7.33 2.94-9.24-22.98 7.33-2.93z"
                        opacity={1}
                        data-original="#81d9e3"
                    />
                    <path
                        fill="#e1ebf4"
                        d="m42.54 83.28-3.6-4.15a32.882 32.882 0 0 1-5.43-8.7l-1.12-2.65 6.08-2.44 1.22 2.89a31.64 31.64 0 0 1 2.42 9.83z"
                        opacity={1}
                        data-original="#e1ebf4"
                        className=""
                    />
                    <path
                        fill="#2d4356"
                        d="M64.5 50a2 2 0 0 0-2 2v2h-1a4.005 4.005 0 0 0-4 4v3a4.004 4.004 0 0 0 4 4h5v3h-7a2 2 0 0 0 0 4h2v2a2 2 0 0 0 4 0v-2h1a4.004 4.004 0 0 0 4-4v-3a4.005 4.005 0 0 0-4-4h-5v-3h7a2 2 0 0 0 0-4h-2v-2a2 2 0 0 0-2-2z"
                        opacity={1}
                        data-original="#2d4356"
                        className=""
                    />
                    <path
                        fill="#2d4356"
                        d="M122 25H99.462A5.952 5.952 0 0 1 101 29h21a2.002 2.002 0 0 1 2 2v70a2.002 2.002 0 0 1-2 2H6a2.002 2.002 0 0 1-2-2V31a2.002 2.002 0 0 1 2-2h5.656a8.91 8.91 0 0 1 3.976-3.14l2.146-.86H6a6.007 6.007 0 0 0-6 6v70a6.007 6.007 0 0 0 6 6h56v4H44a2 2 0 0 0 0 4h40a2 2 0 0 0 0-4H66v-4h56a6.007 6.007 0 0 0 6-6V31a6.007 6.007 0 0 0-6-6z"
                        opacity={1}
                        data-original="#2d4356"
                        className=""
                    />
                    <path
                        fill="#2d4356"
                        d="m96.41 27.59-14-14A2.007 2.007 0 0 0 81 13H37a6.005 6.005 0 0 0-6 6v6.82a8.895 8.895 0 0 1 1.82 2.81L35 34.05V19a2.006 2.006 0 0 1 2-2h42v12a2.006 2.006 0 0 0 2 2h12v62a2.006 2.006 0 0 1-2 2H37a2.006 2.006 0 0 1-2-2v-6.2l-2.1-2.43c-.67-.77-1.3-1.56-1.9-2.37v11a6.005 6.005 0 0 0 6 6h54a6.005 6.005 0 0 0 6-6V29a2.007 2.007 0 0 0-.59-1.41zM83 27v-7.17L90.17 27z"
                        opacity={1}
                        data-original="#2d4356"
                        className=""
                    />
                    <path
                        fill="#81d9e3"
                        d="M90.17 27H83v-7.17z"
                        opacity={1}
                        data-original="#81d9e3"
                    />
                    <g fill="#2d4356">
                        <path
                            d="M85 85a2 2 0 0 0 0-4H50.377l.324 4zM56.21 75a5.998 5.998 0 0 1-2.626-4h-4.555a39.551 39.551 0 0 1 .78 4zM85 71H73.89a8.028 8.028 0 0 1-3.548 4H85a2 2 0 0 0 0-4zM85 61H73.399a7.976 7.976 0 0 1 1.101 4H85a2 2 0 0 0 0-4zM47.012 65H54.6a7.976 7.976 0 0 1-1.101-4h-7.74a5.883 5.883 0 0 1 .224 1.574zM41.94 51.31 43.423 55H54.11a8.028 8.028 0 0 1 3.548-4H43a1.984 1.984 0 0 0-1.06.31zM85 51H71.79a5.998 5.998 0 0 1 2.626 4H85a2 2 0 0 0 0-4z"
                            fill="#2d4356"
                            opacity={1}
                            data-original="#2d4356"
                            className=""
                        />
                    </g>
                    <path
                        fill="#9fa5aa50"
                        d="M31.01 101a9.897 9.897 0 0 0 5.99 2H6a2.006 2.006 0 0 1-2-2v-2a2.006 2.006 0 0 0 2 2zM124 99v2a2.006 2.006 0 0 1-2 2H91a9.897 9.897 0 0 0 5.99-2H122a2.006 2.006 0 0 0 2-2z"
                        opacity={1}
                        data-original="#9fa5aa50"
                    />
                    <path
                        fill="#ad935945"
                        d="M44.84 95H37a2.006 2.006 0 0 1-2-2v-2a2.006 2.006 0 0 0 2 2h3.38a5.966 5.966 0 0 0 4.46 2zM93 91v2a2.006 2.006 0 0 1-2 2H44.84a5.875 5.875 0 0 0 2.12-.39l.19-.07A6.063 6.063 0 0 0 49.41 93H91a2.006 2.006 0 0 0 2-2z"
                        opacity={1}
                        data-original="#ad935945"
                    />
                    <path
                        fill="#a54b3f50"
                        d="m18.41 33.4 1.63 4.03-.7.28-1.27-3.16a.973.973 0 0 1 .34-1.15z"
                        opacity={1}
                        data-original="#a54b3f50"
                    />
                    <path
                        fill="#9fa5aa50"
                        d="m42.54 83.28-3.6-4.15a32.882 32.882 0 0 1-5.43-8.7l-1.12-2.65.72-.29.4.94a32.882 32.882 0 0 0 5.43 8.7l3.42 3.94z"
                        opacity={1}
                        data-original="#9fa5aa50"
                    />
                    <path
                        fill="#fff"
                        d="M100.91 27.98A7.02 7.02 0 0 1 101 29a5.775 5.775 0 0 0-.09-1.02zM124 31v2a2.006 2.006 0 0 0-2-2h-21v-2h21a2.006 2.006 0 0 1 2 2zM11.66 29a8.837 8.837 0 0 0-.94 1.67c-.05.11-.09.22-.13.33H6a2.006 2.006 0 0 0-2 2v-2a2.006 2.006 0 0 1 2-2z"
                        opacity=".5"
                    />
                    <path
                        fill="#f9edd2"
                        d="M79 17v2H37a2.006 2.006 0 0 0-2 2v-2a2.006 2.006 0 0 1 2-2z"
                        opacity=".5"
                    />
                    <path
                        fill="#0f423c"
                        d="m21.52 41.14 9.24 22.98-.69.28-9.24-22.98z"
                        opacity=".3"
                    />
                </g>
            </svg>

        </>
    )
}

export default GstSplit